import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { ADD_REGION } from "../apiRoutes";

const mutateAddGeoRegion = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(ADD_REGION, data);
};

const useAddGeoRegionsMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: mutateAddGeoRegion,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch geo regions queries
      queryClient.invalidateQueries({
        queryKey: ["geoRegions"],
        exact: false,
      });
      queryParams?.onSuccess?.(data, variables, context);
    },
    ...queryParams,
  });
};

export default useAddGeoRegionsMutation;
